import '../assets/styles/jobExperience.css'
import DATA from '../assets/images/data-map.png'
import KAV from '../assets/images/kav.png'
import WHEELIE from '../assets/images/wheelie.png'
import FIVER from '../assets/images/fiver.png'
// import BENEDICT from '../assets/images/benedict.jpg'

const JobExperience = () => {
  const data = [
    {
      id: 1,
      title: 'Wheelie ',
      profession: 'Full-Stack Developer',
      date: '2024 - Present',
      text1: `Designed and implemented a CRM system  utilizing React, PHP, JavaScript, jQuery, and MySQL.`,
      text2: `Delivered customized solutions for the automotive and financial sectors, including loan management tools.`,
      text3: `Led product characterization, task management, and sprint planning using Monday.`,
      text4: `Built scalable, user-centric applications with optimized performance and maintainability.`,
      text5: `Gained hands-on experience with frontend/backend integration and RESTful API development.`,
      text6: `Ensured cross-browser compatibility and adhered to coding standards.`,
      img: WHEELIE,
    },
    {
      id: 2,
      title: 'Freelancer',
      profession: 'Web Developer',
      date: '2022 - 2024',
      text1: `Delivered tailored solutions to meet diverse client needs.`,
      text2: `Managed projects independently, ensuring quality and timely completion.`,
      img: FIVER,
    },
    {
      id: 3,
      title: 'Data-Map Group',
      profession: 'Autocad Drafter',
      date: '2020 - 2022',
      text1: `Produced accurate technical drawings and debugged schematics.`,
      text2: `Streamlined workflows to enhance team efficiency and productivity.`,
      img: DATA,
    },
    
    {
      id: 4,
      title: 'Kav-Medida Group',
      profession: 'Autocad Drafter',
      date: '2018 - 2020',
      text1: `Led teams to execute projects, ensuring alignment with standards.`,
      text2: `Collaborated with engineers to deliver precise technical designs.`,
      text2: `Maintained detailed project documentation for consistency and clarity.`,
      img: KAV,
    },

    // {
    //   id: 3,
    //   title: 'Benedict Restaurant',
    //   profession: 'Operation and Bar Manager',
    //   date: '2012 - 2018',
    //   text1: `Manage all operational aspects of the business to ensure business goals
    //   are met.`,
    //   text2: `Recruit, train, and lead large teams, define work processes, procedures
    //   and targets.`,
    //   text3: `Responsible for short- & long-term commercial planning.`,
    //   img: BENEDICT,
    // },
  ]

  return (
    <section id='job-experience'>
      <h2>My Work Experience</h2>

      <div className='container job-experience-container '>
        <article className='job-experience grid'>
          {data.map(
            ({ id, title, date, text1, text2, text3,text4,text5,text6, img, profession }) => {
              return (
                <section className='job-experience-section' key={id}>
                  <div className='job-experience-complex grid'>
                    <div className='job-experience-img flex'>
                      <img src={img} alt='' />
                    </div>
                    <div className='job-experience-prof flex'>
                      <h3>{title}</h3>
                      <h5>{profession}</h5>
                      <small>{date}</small>
                    </div>
                  </div>

                  <div className='job-experience-about'>
                    <ul>
                      <li>{text1}</li>
                      <li>{text2}</li>
                      <li>{text3}</li>
                      {
                      (
                         (text4 ||  text5 || text6) &&  <>
                        
                    
                          <li>{text4}</li>
                          <li>{text5}</li>
                          <li>{text6}</li>

                          </>
                      )
                      
                      
                      
                      }
                   
                    </ul>
                  </div>
                </section>
              )
            }
          )}
        </article>
      </div>
    </section>
  )
}

export default JobExperience
